export const loginSuccess = "loginSuccess";
export const loginRequest  = "loginRequest ";
export const loginFailure = "loginFailure";
export const resetAuthData = "resetAuthData";
export const updateAuthData = "updateAuthData"
export const updatePermissions = "updatePermissions"
